import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const AreaIcon = (props: SvgProps) => <Svg
  width='24'
  height='24'
  viewBox='0 0 24 24'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M21.2677 12.3862L18.0273 10.5156L14.787 12.3862L18.0273 14.2569L21.2677 12.3862ZM18.0273 9.51562L13.0549 12.3862L18.0273 15.2568L22.9998 12.3862L18.0273 9.51562Z'
    fill={props.color ?? 'white'}
  />
  <Path
    d='M11.9998 6L16.9722 8.87058L11.9998 11.7412L7.02734 8.87058L11.9998 6Z'
    fill={props.color ?? 'white'}
  />
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M15.2403 15.9057L12 14.0351L8.75966 15.9057L12 17.7764L15.2403 15.9057ZM12 13.0352L7.02757 15.9057L12 18.7763L16.9724 15.9057L12 13.0352Z'
    fill={props.color ?? 'white'}
  />
  <Path
    d='M5.97243 9.51953L10.9449 12.3901L5.97243 15.2607L1 12.3901L5.97243 9.51953Z'
    fill={props.color ?? 'white'}
  />
</Svg>;

export default AreaIcon;
